export default "__VITE_ASSET__S21M2kss__"